interface ServiceDescriptionProps {
  description: string;
  features: string[];
}

export default function ServiceDescription({ description, features }: ServiceDescriptionProps) {
  return (
    <div className="bg-white rounded-lg p-8 shadow-sm">
      <div className="border-b border-gray-200 mb-6">
        <button className="text-lg font-semibold text-gray-900 pb-4 border-b-2 border-gray-900">
          Description
        </button>
      </div>

      <p className="text-gray-700 mb-6 leading-relaxed">{description}</p>

      <ul className="space-y-4">
        {features.map((feature, index) => {
          const [title, ...descParts] = feature.split(':');
          const desc = descParts.join(':');
          
          return (
            <li key={index} className="flex gap-3">
              <span className="text-cyan-600 mt-1 flex-shrink-0">
                <i className="ri-checkbox-circle-fill text-lg"></i>
              </span>
              <div>
                <strong className="text-gray-900">{title}:</strong>
                <span className="text-gray-700">{desc}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}